import React, { useState } from "react";
import { FaRegFileAlt } from "react-icons/fa";

const ArticleThumbnail = ({ src, className = "blog-list-thumbnail" }) => {
  const [failedSource, setFailedSource] = useState(null);
  return (
    <div className={className} aria-hidden="true">
      {src && src !== failedSource ? (
        <img src={src} alt="" loading="lazy" decoding="async" width="120" height="120" onError={() => setFailedSource(src)} />
      ) : <FaRegFileAlt size={28} />}
    </div>
  );
};

export default ArticleThumbnail;
